import React from "react";
import { Table, Icon } from "antd";
import TablePageSize from "../../../../../../common/components/TablePageSize";

const placeholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const OrdersTable = props => {
  const {
    renderColumns,
    tableColumnsLen,
    offers,
    pagination,
    handleClickRow,
    offersLoading,
    sortByColumn,
    onPageSizeChange,
    onPageChange
  } = props;

  return (
    <div className="orders__table">
      <Table
        locale={{
          emptyText: offersLoading ? placeholder : "Предложений нет..."
        }}
        columns={renderColumns()}
        dataSource={offers}
        rowKey="id"
        pagination={{
          pageSize: pagination ? pagination.limit : 0,
          total: pagination ? pagination.total : 0,
          current: pagination ? pagination.page : 0
        }}
        onRow={handleClickRow}
        onChange={(pag, filters, sorter) => {
          //На основе аргументов вызывать разные колбеки изменений (страница, кол-во результатов, сортировку)
          if (
            pag.pageSize !== pagination.limit ||
            pag.current !== pagination.page
          ) {
            onPageChange(pag);
          } else if (sorter) {
            sortByColumn(sorter);
          }
        }}
        // rowSelection={rowSelection}
        scroll={tableColumnsLen > 8 ? { x: "140%" } : { x: false }}
        rowClassName="pointer"
      />
      {offers && offers.length > 0 ? (
        <TablePageSize
          pages={pagination.limit}
          changePaginationSize={onPageSizeChange}
        />
      ) : null}
    </div>
  );
};

export default OrdersTable;
